import axios from "../../../axios/axios";
import { CenikItem } from "../../../ts/Cenik";

export const FETCH_CENIK = async (id: string) => {
  return new Promise<CenikItem[]>((resolve, reject) => {
    axios.get("/eshop/fetch-cenik", {
      params: {
        id,
      },
    });
    //   .then((val) => {
    //     resolve(mapCenikToCenikItems(val.data));
    //   });
  });
};

export type TCenikCombinationItem = {
  id: string;
  name: string;
  items: CenikItem[];
};

type TWithIDAndName<T> = T & { id: string; name: string };

export const mapCenikToCenikItems = (
  cenik: TWithIDAndName<any>[]
): TCenikCombinationItem[] => {
  let mappedArr: TCenikCombinationItem[] = [];

  cenik.forEach((p: TWithIDAndName<any>) => {
    const items: CenikItem[] = [];

    if (p.combinations?.length > 0) {
      p.combinations.forEach((c: any) => {

        items.push({
          id: c.id,
          cennikova_cena:
            parseFloat(p.price) + (c?.price ? parseFloat(c.price) : 0),
          dokoncena_stena: c?.product_option_values?.ds ?? "",
          kod: c?.reference,
          mj: "ks",
          popis: p.name,
          sirka: c?.product_option_values?.l ?? "",
          vyska: c?.product_option_values?.h ?? "",
        });
      });
    } else {
      items.push({
        id: p.id,
        cennikova_cena: parseFloat(p.price),
        dokoncena_stena: "",
        kod: p.reference,
        mj: "ks",
        popis: p.name,
        sirka: p.width,
        vyska: p.height,
      });
    }

    mappedArr.push({
      id: p.id,
      name: p.name,
      items,
    });
  });

  return mappedArr;
};
